import { useMutation } from '@tanstack/react-query'
import { createDistributionRule } from 'services/RewardsService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { CreateDistributionRuleRequest } from 'types/rewards'

export const useUpdateEarningsDistributionMutation = () =>
  useMutation<void, BaseErrorResponse, CreateDistributionRuleRequest>({
    mutationFn: createDistributionRule,
  })
